import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";
import { loadWaveformThunk } from "thunks/player";

const initialState = {
  playing: false,
  current: null,
  finished: false,
  meta: {},
  waveformDataHash: {},
  loadingHash: {},
  error: null,
  instancePause: false,
  instancePlay: false,
  destroy: false,
  playedCount: 0,
};

const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    playerPlay(state, action) {
      const { recordingId, meta } = action.payload;
      state.instancePlay = false;
      state.instancePause = false;
      state.playing = true;
      state.current = recordingId;
      state.finished = false;
      state.meta = { ...state.meta, meta };
    },
    playerPause(state, action) {
      const finished = action.payload;
      state.playing = false;
      state.finished = finished || false;
      state.instancePlay = false;
      state.instancePause = false;
    },
    playerContinue(state) {
      state.playing = true;
      state.finished = false;
    },
    playerStop(state, action) {
      const { forceStop, recordingId } = action.payload;
      const shouldStopAudio =
        forceStop ||
        recordingId === state.current ||
        state.loadingHash[recordingId];
      if (shouldStopAudio) {
        state.destroy = state.current;
        state.playing = false;
        state.current = null;
        state.meta = {};
        state.instancePlay = false;
        state.instancePause = false;
      }
    },
    playerSetLoadingFalse(state, action) {
      const { recordingId } = action.payload;
      state.loadingHash[recordingId] = false;
    },
    playerInstancePause(state) {
      state.instancePause = !state.instancePause;
    },
    playerInstancePlay(state) {
      state.instancePlay = !state.instancePlay;
    },
    playerDestroy(state) {
      state.destroy = !state.destroy;
    },
    resetPlayedCount(state) {
      state.playedCount = 0;
    },
    incrementPlayed(state) {
      state.playedCount += 1;
    },
  },
  extraReducers: (builder) => {
    builder
      // #region pending
      .addCase(loadWaveformThunk.pending, (state, action) => {
        const { recordingId } = action.meta.arg;
        state.loadingHash[recordingId] = true;
      })
      // #endregion
      // #region fulfilled
      .addCase(loadWaveformThunk.fulfilled, (state, action) => {
        const { recordingId, waveformData } = action.payload;
        state.waveformDataHash[recordingId] = waveformData;
      })
      // #endregion
      // #region rejected
      .addCase(loadWaveformThunk.rejected, (state, action) => {
        const { error } = action;
        state.error = error;
      })
      // #endregion
      .addCase(clearStore, () => initialState);
  },
});

export const actions = playerSlice.actions;

export default playerSlice.reducer;
